import { render, staticRenderFns } from "./RecentReferralsBlock.vue?vue&type=template&id=4fd53a6a&"
import script from "./RecentReferralsBlock.vue?vue&type=script&lang=ts&"
export * from "./RecentReferralsBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports